import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Switch, Avatar, Form, Input } from "antd";
import {
  UserOutlined,
  LockOutlined,
  TrophyOutlined,
  PlayCircleOutlined,
  CustomerServiceOutlined,
  QuestionCircleOutlined,
  FileProtectOutlined,
  DeleteOutlined,
  LogoutOutlined,
  RightOutlined,
} from "@ant-design/icons";
import ConfirmationModal from "../../../components/modals/ConfirmationModal.jsx";
import {
  Verify2faChangeApi,
  LogoutApi,
  Request2faChangeApi,
} from "../../../api/request/users.js";
import { setloggedIn } from "../../../store/slices/userSlice.js";
import { removeCookies } from "../../../services/Cookies.jsx";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";

const SettingsMobile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formotp] = Form.useForm();
  const { userDetails } = useSelector((state) => state?.user);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [verifyWithOpt, setVerifyWithOpt] = useState(() => {
    const stored = localStorage.getItem("verifyWithOpt");
    return stored ? JSON.parse(stored) : false;
  });
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(verifyWithOpt);
  const [twoFactorLoading, setTwoFactorLoading] = useState(false);
  const [FormData, setFormData] = useState({ email: "" });
  const [timer, setTimer] = useState(0);
  const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);

  const menuItems = [
    {
      id: "two-factor-auth",
      title: "Two Factor Authentication",
      icon: <LockOutlined className="text-gray-600" />,
      hasArrow: false,
    },
    {
      id: "kyc",
      title: "KYC",
      icon: <QuestionCircleOutlined className="text-gray-600" />,
      hasArrow: true,
    },
    {
      id: "change-password",
      title: "Change Password",
      icon: <LockOutlined className="text-gray-600" />,
      hasArrow: true,
    },
    {
      id: "leaderboard",
      title: "Leaderboard",
      icon: <TrophyOutlined className="text-gray-600" />,
      hasArrow: true,
    },
    {
      id: "transaction",
      title: "My Transaction",
      icon: <TrophyOutlined className="text-gray-600" />,
      hasArrow: true,
    },
    {
      id: "tutorial",
      title: "Tutorial",
      icon: <PlayCircleOutlined className="text-gray-600" />,
      hasArrow: true,
    },
    {
      id: "support",
      title: "Support",
      icon: <CustomerServiceOutlined className="text-gray-600" />,
      hasArrow: true,
    },
    {
      id: "faqs",
      title: "FAQ's",
      icon: <QuestionCircleOutlined className="text-gray-600" />,
      hasArrow: true,
    },

    // {
    //   id: "privacy-policy",
    //   title: "Privacy Policy",
    //   icon: <FileProtectOutlined className="text-gray-600" />,
    //   hasArrow: true,
    // },
    // {
    //   id: "delete-account",
    //   title: "Delete Account",
    //   icon: <DeleteOutlined className="text-gray-600" />,
    //   hasArrow: true,
    // },
  ];

  const handleMenuClick = (itemId) => {
    switch (itemId) {
      case "edit-profile":
        navigate("/profile");
        break;
      case "change-password":
        navigate("/change_password");
        break;
      case "kyc":
        navigate("/kyc");
        break;
      case "leaderboard":
        navigate("/leaderboard");
        break;
      case "tutorial":
        navigate("/tutorials");
        break;
      case "support":
        navigate("/support");
        break;
      case "faqs":
        navigate("/faq");
        break;
      case "privacy-policy":
        navigate("/privacy-policy");
        break;
      case "transaction":
        navigate("/my_transaction");
        break;
      case "delete-account":
        navigate("/delete-account");
        break;
      default:
        console.log("Menu item clicked:", itemId);
    }
  };

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi();
      if (data?.success) {
        toast.success(data?.message);
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsModalOpen(false);
      setIsLoading(false);
    } catch (err) {
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsModalOpen(false);
      setIsLoading(false);
    }
  };

  const open2FAHandle = async () => {
    setTwoFactorLoading(true);
    const success = await resendOTPHandler(!verifyWithOpt);
    if (success) {
      setFormData({ otp: "" });
      setTimer(120);
      setIsOpen2FAModal(true);
    }
    setTwoFactorLoading(false);
  };

  const resendOTPHandler = async (values) => {
    try {
      const { data } = await Request2faChangeApi(values);
      if (data?.success) {
        toast.success(data?.message);
        return true;
      }
    } catch (err) { }
    return false;
  };

  const handleSubmit2FA = async (values) => {
    const { otp } = values;
    if (!otp) {
      toast.error("OTP can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        userId: userDetails?.id,
        Otp: otp,
        isActiveFlag: !verifyWithOpt,
      };
      const { data } = await Verify2faChangeApi(params);
      if (data?.success) {
        toast.success(data?.message);
        const newValue = !verifyWithOpt;
        setVerifyWithOpt(newValue);
        localStorage.setItem("verifyWithOpt", JSON.stringify(newValue));
        formotp.resetFields();
        setIsOpen2FAModal(false);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error?.message || "Something went wrong"
      );
      setIsLoading(false);
    }
  };

  const formatTime = (timer) => {
    const minutes = Math.floor(timer / 60);
    const remainingSeconds = timer % 60;
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(remainingSeconds).padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const onChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    setFormData({ ...FormData, otp: newValue });
  };

  const sharedProps = {
    onChange,
  };

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("verifyWithOpt"));
    if (stored !== null) {
      setVerifyWithOpt(JSON.parse(stored));
    }
  }, []);

  return (
    <>
      <div className="min-h-screen">
        {/* User Profile Section */}
        <div className="rounded-lg p-4 mb-6 bg-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Avatar
                size={64}
                src={userDetails?.profilePicture || null}
                icon={!userDetails?.profilePicture && <UserOutlined />}
                className="bg-gray-400"
              />
              <div>
                <h3 className="text-lg font-bold text-gray-800">
                  {userDetails?.firstName && userDetails?.lastName
                    ? `${userDetails.firstName} ${userDetails.lastName}`
                    : userDetails?.email || "Daniel Walker"}
                </h3>
              </div>
            </div>
            <button
              className="w-8 h-8 bg-[#E2E8F0] rounded-[10px] transition-colors"
              onClick={() => handleMenuClick("edit-profile")}
            >
              <RightOutlined className="text-[#45556C] text-sm" />
            </button>
          </div>
        </div>

        {/* Menu Items */}
        <div className="space-y-3 mb-8">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-lg p-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors"
              onClick={() => handleMenuClick(item.id)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="h-10 w-10 grid place-items-center bg-[#E2E8F0] rounded-[14px]">
                    {item.icon}
                  </div>
                  <span className="text-gray-800 font-medium">
                    {item.title}
                  </span>
                </div>
                {item.id === "two-factor-auth" && (
                  <div className="flex items-center space-x-2">
                    <Switch
                      checked={twoFactorEnabled}
                      onChange={() => {
                        setTwoFactorEnabled(!twoFactorEnabled);
                        open2FAHandle();
                      }}
                      loading={twoFactorLoading}
                      disabled={twoFactorLoading}
                    />
                  </div>
                )}
                {item.hasArrow && (
                  <button
                    className="w-8 h-8 bg-[#E2E8F0] rounded-[10px] transition-colors"
                    onClick={() => handleMenuClick("edit-profile")}
                  >
                    <RightOutlined className="text-[#45556C] text-sm" />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Logout Button */}
        <div className="mb-8">
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors flex items-center justify-center space-x-2"
          >
            <LogoutOutlined />
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* --- Logout confirmation modal --- */}
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        message="Are you sure you want to logout?"
        onConfirm={handleLogout}
        isLoading={isLoading}
        loadingLabel="Logging out..."
      />

      <ModalComponent
        isOpen={isOpen2FAModal}
        setIsOpen={setIsOpen2FAModal}
        title="Two Factor Authentication"
        width={600}
      >
        <div className="sm:grid grid-cols-12 justify-center items-center ">
          <div className="md:col-span-12 col-span-5 flex flex-col bg-[#FFFFFF] justify-center items-center px-10 py-10 gap-6  w-full">
            <div className="text-center">
              <p className="text-[#da3a3a] text-sm font-medium auth-com mt-2">
                A verification code has been sent to your email address:{" "}
                {userDetails?.email}
              </p>
              <p className="text-[silver] text-sm font-medium auth-com mt-2  ">
                Please enter the OTP and verify yourself
              </p>
            </div>
            <div className="w-full">
              <Form
                autoComplete="off"
                form={formotp}
                onFinish={handleSubmit2FA}
              >
                <div className="w-full text-sm py-1">
                  <div className="relative">
                    <Form.Item
                      name="otp"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input.OTP {...sharedProps} style={{ width: "100%" }} />
                    </Form.Item>
                  </div>
                </div>
                <div className="my-6 flex justify-center">
                  {timer == 0 ? (
                    <button
                      type="button"
                      onClick={open2FAHandle}
                      className="text-sm primary font-bold"
                    >
                      <span className="text-black font-normal">
                        Didn't receive it?
                      </span>{" "}
                      Resend OTP
                    </button>
                  ) : (
                    <p>Resend OTP in {formatTime(timer)}</p>
                  )}
                </div>
                <div className="mt-8">
                  <LoadableButton
                    type="submit"
                    className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text"
                    lable="Verify"
                    isLoading={isLoading}
                    loadingLable="Verifying..."
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default SettingsMobile;
